import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isSignedIn = localStorage.getItem('login_data') !== null

  const user = useSelector(state => state.user)
  return (
        <Route {...rest} render={(props) => (
          !!isSignedIn === true
            ? <Component {...props} />
            : <Redirect to={'/login'} />
        )} />

  )
}

export default PrivateRoute
